function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import IllegalArgumentException from '../../../../java/lang/IllegalArgumentException';
import GeometryComponentFilter from './GeometryComponentFilter';
import Comparable from '../../../../java/lang/Comparable';
import Cloneable from '../../../../java/lang/Cloneable';
import Serializable from '../../../../java/io/Serializable';
import Envelope from './Envelope';
var Geometry = /*#__PURE__*/function () {
  function Geometry() {
    _classCallCheck(this, Geometry);
    Geometry.constructor_.apply(this, arguments);
  }
  return _createClass(Geometry, [{
    key: "isGeometryCollection",
    value: function isGeometryCollection() {
      return this.getTypeCode() === Geometry.TYPECODE_GEOMETRYCOLLECTION;
    }
  }, {
    key: "getFactory",
    value: function getFactory() {
      return this._factory;
    }
  }, {
    key: "getGeometryN",
    value: function getGeometryN(n) {
      return this;
    }
  }, {
    key: "getArea",
    value: function getArea() {
      return 0.0;
    }
  }, {
    key: "isRectangle",
    value: function isRectangle() {
      return false;
    }
  }, {
    key: "equals",
    value: function equals() {
      if (arguments[0] instanceof Geometry) {
        var g = arguments[0];
        if (g === null) return false;
        return this.equalsTopo(g);
      } else if (arguments[0] instanceof Object) {
        var o = arguments[0];
        if (!(o instanceof Geometry)) return false;
        var _g = o;
        return this.equalsExact(_g);
      }
    }
  }, {
    key: "equalsExact",
    value: function equalsExact(other) {
      return this === other || this.equalsExact(other, 0);
    }
  }, {
    key: "geometryChanged",
    value: function geometryChanged() {
      this.apply(Geometry.geometryChangedFilter);
    }
  }, {
    key: "geometryChangedAction",
    value: function geometryChangedAction() {
      this._envelope = null;
    }
  }, {
    key: "equalsNorm",
    value: function equalsNorm(g) {
      if (g === null) return false;
      return this.norm().equalsExact(g.norm());
    }
  }, {
    key: "getLength",
    value: function getLength() {
      return 0.0;
    }
  }, {
    key: "getNumGeometries",
    value: function getNumGeometries() {
      return 1;
    }
  }, {
    key: "compareTo",
    value: function compareTo() {
      var other;
      if (arguments.length === 1) {
        var o = arguments[0];
        other = o;
        if (this.getTypeCode() !== other.getTypeCode()) {
          return this.getTypeCode() - other.getTypeCode();
        }
        if (this.isEmpty() && other.isEmpty()) {
          return 0;
        }
        if (this.isEmpty()) {
          return -1;
        }
        if (other.isEmpty()) {
          return 1;
        }
        return this.compareToSameClass(o);
      } else if (arguments.length === 2) {
        var _o = arguments[0];
        var comp = arguments[1];
        other = _o;
        if (this.getTypeCode() !== other.getTypeCode()) {
          return this.getTypeCode() - other.getTypeCode();
        }
        if (this.isEmpty() && other.isEmpty()) {
          return 0;
        }
        if (this.isEmpty()) {
          return -1;
        }
        if (other.isEmpty()) {
          return 1;
        }
        return this.compareToSameClass(_o, comp);
      }
    }
  }, {
    key: "getUserData",
    value: function getUserData() {
      return this._userData;
    }
  }, {
    key: "getSRID",
    value: function getSRID() {
      return this._SRID;
    }
  }, {
    key: "getEnvelope",
    value: function getEnvelope() {
      return this.getFactory().toGeometry(this.getEnvelopeInternal());
    }
  }, {
    key: "checkNotGeometryCollection",
    value: function checkNotGeometryCollection(g) {
      if (g.getTypeCode() === Geometry.TYPECODE_GEOMETRYCOLLECTION) {
        throw new IllegalArgumentException('This method does not support GeometryCollection arguments');
      }
    }
  }, {
    key: "equal",
    value: function equal(a, b, tolerance) {
      if (tolerance === 0) {
        return a.equals(b);
      }
      return a.distance(b) <= tolerance;
    }
  }, {
    key: "norm",
    value: function norm() {
      var copy = this.copy();
      copy.normalize();
      return copy;
    }
  }, {
    key: "getPrecisionModel",
    value: function getPrecisionModel() {
      return this._factory.getPrecisionModel();
    }
  }, {
    key: "getEnvelopeInternal",
    value: function getEnvelopeInternal() {
      if (this._envelope === null) {
        this._envelope = this.computeEnvelopeInternal();
      }
      return new Envelope(this._envelope);
    }
  }, {
    key: "setSRID",
    value: function setSRID(SRID) {
      this._SRID = SRID;
    }
  }, {
    key: "setUserData",
    value: function setUserData(userData) {
      this._userData = userData;
    }
  }, {
    key: "compare",
    value: function compare(a, b) {
      var i = a.iterator();
      var j = b.iterator();
      while (i.hasNext() && j.hasNext()) {
        var aElement = i.next();
        var bElement = j.next();
        var comparison = aElement.compareTo(bElement);
        if (comparison !== 0) {
          return comparison;
        }
      }
      if (i.hasNext()) {
        return 1;
      }
      if (j.hasNext()) {
        return -1;
      }
      return 0;
    }
  }, {
    key: "hashCode",
    value: function hashCode() {
      return this.getEnvelopeInternal().hashCode();
    }
  }, {
    key: "isGeometryCollectionOrDerived",
    value: function isGeometryCollectionOrDerived() {
      if (this.getTypeCode() === Geometry.TYPECODE_GEOMETRYCOLLECTION || this.getTypeCode() === Geometry.TYPECODE_MULTIPOINT || this.getTypeCode() === Geometry.TYPECODE_MULTILINESTRING || this.getTypeCode() === Geometry.TYPECODE_MULTIPOLYGON) {
        return true;
      }
      return false;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [Cloneable, Comparable, Serializable];
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return Geometry;
    }
  }], [{
    key: "hasNonEmptyElements",
    value: function hasNonEmptyElements(geometries) {
      for (var i = 0; i < geometries.length; i++) {
        if (!geometries[i].isEmpty()) {
          return true;
        }
      }
      return false;
    }
  }, {
    key: "hasNullElements",
    value: function hasNullElements(array) {
      for (var i = 0; i < array.length; i++) {
        if (array[i] === null) {
          return true;
        }
      }
      return false;
    }
  }]);
}();
export { Geometry as default };
;
Geometry.constructor_ = function (factory) {
  if (!factory) {
    return;
  }
  this._envelope = null;
  this._userData = null;
  this._factory = factory;
  this._SRID = factory.getSRID();
};
Geometry.serialVersionUID = 8763622679187376702;
Geometry.TYPECODE_POINT = 0;
Geometry.TYPECODE_MULTIPOINT = 1;
Geometry.TYPECODE_LINESTRING = 2;
Geometry.TYPECODE_LINEARRING = 3;
Geometry.TYPECODE_MULTILINESTRING = 4;
Geometry.TYPECODE_POLYGON = 5;
Geometry.TYPECODE_MULTIPOLYGON = 6;
Geometry.TYPECODE_GEOMETRYCOLLECTION = 7;
Geometry.TYPENAME_POINT = 'Point';
Geometry.TYPENAME_MULTIPOINT = 'MultiPoint';
Geometry.TYPENAME_LINESTRING = 'LineString';
Geometry.TYPENAME_LINEARRING = 'LinearRing';
Geometry.TYPENAME_MULTILINESTRING = 'MultiLineString';
Geometry.TYPENAME_POLYGON = 'Polygon';
Geometry.TYPENAME_MULTIPOLYGON = 'MultiPolygon';
Geometry.TYPENAME_GEOMETRYCOLLECTION = 'GeometryCollection';
Geometry.geometryChangedFilter = {
  get interfaces_() {
    return [GeometryComponentFilter];
  },
  filter: function filter(geom) {
    geom.geometryChangedAction();
  }
};